import { EventEmitter, HostListener } from '@angular/core';
import { Directive, Output } from '@angular/core';

@Directive({
  selector: '[apppopstateClick]'
})
export class CloserightOverlay {

  constructor() { }

  @Output()  apppopstateClick = new EventEmitter();
  @HostListener('window:popstate', ['$event'])
  handleBrowserBackButton() {
    this.apppopstateClick.emit("Broswer Back Button click");
  }
}
